import { actualDefaultLocale, localesArr } from '@/lang/locales';

import { ILocale } from '@/lang/types';
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';

export const useSwitchLang = () => {
  const { pathname, query, asPath, replace } = useRouter();

  const queryClient = useQueryClient();

  const switchLang = useCallback(
    /* A function that is being called when the user clicks on a language. */
    (lang: ILocale) => {
      const newLang = localesArr.includes(lang) ? lang : actualDefaultLocale;

      replace({ pathname, query }, asPath, { locale: newLang });
      queryClient.invalidateQueries();
    },
    [replace, pathname, query, asPath, queryClient]
  );

  return {
    switchLang,
  };
};
